<template>
  <div class="content">
    <div class="img_box">
      <div class="img_center">
        <div class="img_text">
          <div class="img_title">公司介绍</div>
        </div>
      </div>
    </div>

    <div class="contentCenter h7VzDKwB" v-for="(item, index) in productArr" :key="index" v-lazy-container="{ selector: 'img' }">
      <div class="title">
        <template v-if="item.leftText && item.leftText.length > 0">
          <span style="color: #333">{{ item.leftText[0] }}</span><span style="color: #0171bb">{{ item.leftText[1] }}</span>
        </template>
        <!-- <span v-if="item.rightText">{{ item.rightText }}</span> -->
      </div>
      <div v-if="item.companyProfile" class="company-profile-container">
        <div class="company-profile__text">
          <div v-for="(itemCompanyProfile, indexCompanyProfile) in item.companyProfile.text" :key="indexCompanyProfile">{{itemCompanyProfile}}</div>
        </div>
        <img :data-src="item.companyProfile.image" alt="" class="company-profile__img">
      </div>
      <div class="text" v-if="item.text">{{ item.text }}</div>
      <div class="park" v-if="item.picArr">
        <div
          class="parkLi"
          v-for="(items, indexs) in item.picArr"
          v-lazy-container="{ selector: 'img' }"
          :key="indexs"
        >
          <img :data-src="items.url" alt="" />
          <div class="parkText">
            <div class="parkTextTitle">{{ items.title }}</div>
            <div class="parkSamllText">{{ items.text }}</div>
          </div>
        </div>
      </div>
      <div class="certificate" v-if="item.certificateArr">
        <div class="certificateLeft">
          <!-- <div class="certificateLeftBtn">
            <div>
              <el-button
                type="primary"
                icon="el-icon-arrow-up"
                size="mini"
                @click="currentDown"
                :disabled="downdisable"
              ></el-button>
            </div>
            <div>
              <el-button
                type="primary"
                icon="el-icon-arrow-down"
                size="mini"
                @click="currentUp"
                :disabled="updisable"
              ></el-button>
            </div>
          </div> -->
          <div
            class="certificateLeftTitle"
            v-for="(item, index) in labelArr"
            :key="index"
            ref="btn"
            @click="changePic(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="certificateRight">
          <template v-for="(items, indexs) in item.certificateArr[currentNum]" v-lazy-container="{ selector: 'img' }">
            <div v-if="items.type == 'empty'" style="width: 220px;" :key="indexs"></div>
            <div
              v-else
              class="certificateRightLi"
              :key="indexs"
            >
            <template v-if="items.tooltipText">
              <el-tooltip class="item" effect="dark" :content="items.tooltipText" placement="bottom">
                <img :data-src="items.url" alt="" />
              </el-tooltip>
            </template>
            <template v-else>
              <img :data-src="items.url" alt="" />
            </template>
            </div>
          </template>
        </div>
      </div>
      <div v-if="item.historyArr" class="stepBlock">
        <div style="flex: 0 0 0px;">
          <el-button
            type="primary"
            icon="el-icon-arrow-left"
            @click="goBack"
            :disabled="curYear <= 0"
          ></el-button>
        </div>
        <el-steps
          :active="curYear"
          align-center
          finish-status="wait"
          process-status="process"
          style="flex: 1 1 auto;"
        >
          <el-step
            v-for="(items, indexs) in item.historyArr"
            :key="indexs"
          >
            <template slot="icon">
              <i
                @click="handleClick(indexs)"
                ref="icon"
                style="color: transparent; font-size: large"
                >{{ indexs }}</i
              >
            </template>
            <template slot="title">
              <div v-if="indexs % 2 == 0">
                <i class="el-icon-caret-top" style="opacity:0" id="caret"></i><br />
                <span>{{ items.year }}</span>
              </div>
              <div v-if="indexs % 2 != 0">
                <span>{{ items.year }}</span
                ><br />
                <i class="el-icon-caret-bottom" style="opacity:0" id="caret"></i>
              </div>
            </template>
            <template slot="description">
              <div v-for="(item_des, index_des) in items.text_list" :key="index_des">
                {{item_des}}
              </div>
            </template>
          </el-step>
        </el-steps>
        <div style="flex: 0 0 0px;">
          <el-button
            type="primary"
            icon="el-icon-arrow-right"
            @click="goFulture"
            :disabled="curYear >= 4"
          ></el-button>
        </div>

        <!-- <el-steps :active="5" align-center direction="vertical">
          <el-step
            v-for="(items, indexs) in item.historyArr"
            :key="indexs"
            :title="items.year"
            :description="items.text"
          ></el-step>
        </el-steps> -->
      </div>
      <div v-if="item.historyArr" class="timeLine">
        <el-timeline reverse>
          <el-timeline-item
            type="primary"
            v-for="(activity, index) in item.historyArr"
            :key="index"
            :timestamp="activity.year"
            placement="top"
          >
            {{ activity.text }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="map" id="allmap">
      <img v-lazy="require('../assets/map_location.png')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "companyIntroduction",
  data() {
    return {
      curYear: 4,
      currentNum: 0,
      downdisable: true,
      updisable: false,
      labelArr: ["企业资质", "知识产权", "荣誉证书", "行业合作"],
      productArr: [
        {
          leftText: ['公司','简介'],
          rightText: "",
          companyProfile: {
            image: require("../assets/company-profile.jpg"),
            text:[
              '思百达物联网科技（北京）有限公司（Spider-IoT Technology（Beijing）Co., Ltd. 简称“思百达物联”、Spider-IoT）以AIoT技术为抓手，致力于人工智能、物联网、大数据等新一代信息技术的研发创新和应用落地。公司坚持“数字化”、“智慧化”的产品发展战略，遵循“两翼齐飞（服务政企市场）、多机驱动（支持私有云、公有云、混合云部署）、云端共存（多端连接、服务云化）、价值服务（注重产品价值的创造、传递、收获）”的产品研发和应用策略。',
              '思百达物联（Spider-IoT）是北京市“专精特新”中小企业、国家高新技术企业、中关村高新技术企业、国家科技型中小企业、北京市创新型中小企业、知识产权保护中心备案企业，和A级纳税人，并通过了ISO9001和ISO45001等多项认证。公司连续三年荣获“中关村创业生态发展促进会”颁发的研发资金支持。公司专利申请总数20余项（其中发明专利19项），软著36项，涵盖了图像处理、机器视觉、物联网、大数据等技术领域，并被评为“北京市知识产权示范单位”。公司2023年成功入选中国电信集团有限公司交通物流产业研究院的“智慧物流生态合作伙件”。'
            ]
          },
        },
        {
          leftText: ['企业','文化'],
          rightText: "Corporate Culture",
          picArr: [
            {
              url: require("../assets/about3.png"),
              title: "价值观",
              text: "正直、自驱、创新、共赢",
            },
            {
              url: require("../assets/about1.png"),
              title: "愿景",
              text: "服务于中国及全球企业的领先AIoT应用赋能提供商",
            },
            {
              url: require("../assets/about2.png"),
              title: "使命",
              text: "共创人机同行的美好世界",
            },
          ],
        },
        {
          leftText: ['资质','证书'],
          rightText: "Certificate",
          certificateArr: [
            [
              {
                url: require("../assets/copyright.png"),
              },
              {
                url: require("../assets/zizhi5.jpg"),
              },
              {
                url: require("../assets/zizhi2.jpg"),
              },
              {
                url: require("../assets/zizhi1.png"),
              },
              {
                url: require("../assets/zizhi7.png"),
              },
              {
                url: require("../assets/zizhi3.jpg"),
              },
              {
                url: require("../assets/zizhi4.jpg"),
              },
              {
                url: require("../assets/zizhi6.jpg"),
              },
            ],
            [
              {
                url: require("../assets/chanquan3.jpg"),
                tooltipText: '专利申请16个，授权发明专利6个'
              },
              {
                url: require("../assets/chanquan4.png"),
                tooltipText: '33个软著'
              },
              {
                url: require("../assets/chanquan1.jpg"),
                tooltipText: '41个商标'
              },
              {
                url: require("../assets/chanquan2.jpg"),
                tooltipText: '2个顶级国际域名'
              },
            ],
            [
              {
                url: require("../assets/zhengshu1.png"),
              },
              {
                url: require("../assets/zhengshu2.jpg"),
              },
              {
                url: require("../assets/zhengshu3.png"),
              },
              {
                url: require("../assets/zhengshu4.jpg"),
              },
              {
                url: require("../assets/zhengshu5.jpg"),
              },
              {
                type: 'empty',
              },
              {
                type: 'empty',
              },
              {
                type: 'empty',
              },
            ],
            [
              {
                url: require("../assets/hezuo1.jpg"),
              },
              {
                url: require("../assets/hezuo2.jpg"),
              },
              {
                url: require("../assets/hezuo3.jpg"),
              },
              {
                url: require("../assets/hezuo4.jpg"),
              },
              {
                url: require("../assets/hezuo5.jpg"),
              },
              {
                url: require("../assets/hezuo6.jpg"),
              },
              {
                type: 'empty',
              },
              {
                type: 'empty',
              },
            ],
          ],
        },
        // {
        //   leftText: "发展历史",
        //   rightText: "History",
        //   historyArr: [
        //     {
        //       year: "2017",
        //       text: "1月成立公司,6月获天使轮投资,10月组建研发团队",
        //       text_list: [
        //         '1月成立公司',
        //         '6月获天使轮投资',
        //         '10月组建研发团队'
        //       ],
        //     },
        //     {
        //       year: "2018",
        //       text: "12月发布智慧园区一体化综合管控操作系统1.0,8月通过国家“知识产权管理体系认证”,7月获“国家高新技术企业”认证",
        //       text_list: [
        //         '12月发布智慧园区一体化综合管控操作系统1.0',
        //         '8月通过国家“知识产权管理体系认证”','7月获“国家高新技术企业”认证'
        //       ],
        //     },
        //     {
        //       year: "2019",
        //       text: "4月与泰康健投联合参加,“第一届世界大健康博览会”，并展出智慧养老,解决方案，被中央台和湖北卫视报道,6月获“中关村高新技术企业”认证,11月获中关村科技型小微企业研发费用补贴",
        //       text_list: [
        //         '4月与泰康健投联合参加,“第一届世界大健康博览会”，并展出智慧养老,解决方案，被中央台和湖北卫视报道',
        //         '6月获“中关村高新技术企业”认证',
        //         '11月获中关村科技型小微企业研发费用补贴'
        //       ]
        //     },
        //     {
        //       year: "2020",
        //       text: "9月被评为“2020年度北京知识产权试点示范单位”,6月获ISO9001和ISO45001认证,5月发布智慧园区一体化综合管控操作系统2.0",
        //       text_list: [
        //         '9月被评为“2020年度北京知识产权试点示范单位”',
        //         '6月获ISO9001和ISO45001认证',
        //         '5月发布智慧园区一体化综合管控操作系统2.0'
        //       ],
        //     },
        //     {
        //       year: "2021",
        //       text: "11月第三次获得科技型小微研发费用支持资金,10月再次获得“国家高新技术企业”；首次获得“安防工程企业设计施工维护能力证书”三级认证,5月再次获ISO9001和ISO45001认证",
        //       text_list: [
        //         '11月第三次获得科技型小微研发费用支持资金',
        //         '10月再次获得“国家高新技术企业”；首次获得“安防工程企业设计施工维护能力证书”三级认证',
        //         '5月再次获ISO9001和ISO45001认证'
        //       ]
        //     },
        //   ],
        // },
        {
          leftText: ['联系','我们'],
          rightText: "Contact Us",
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.$refs["btn"][this.currentNum].classList.add("isCurrent");
  },
  methods: {
    handleClick(e) {
      this.curYear = e;
    },
    goFulture() {
      this.curYear++;
    },
    goBack() {
      this.curYear--;
    },
    changePic(index) {
      this.currentNum = index;
      this.$refs["btn"].map((e, i) => {
        i == index
          ? e.classList.add("isCurrent")
          : e.classList.remove("isCurrent");
      });
    },
  },
};
</script>

<style>
.h7VzDKwB .el-step__description.is-wait,.h7VzDKwB .el-step__description.is-process {
  text-align: left;
}
</style>

<style scoped>
.company-profile-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1180px;
  margin: 64px auto 0;
}
.company-profile-container .company-profile__text {
  margin-right: 80px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.company-profile-container .company-profile__text > div:nth-child(2) {
  margin-top: 20px;
}
.company-profile-container .company-profile__img {
  width: 500px;
  height: 300px;
}
@media (max-width: 992px) {
  .company-profile-container {
    flex-direction: column-reverse;
  }
  .company-profile-container .company-profile__text {
    margin-right: 0;
    padding: 0 30px;
  }
  .company-profile-container .company-profile__img {
    margin-bottom: 20px;
  }
}
/* 自定义步骤条start */
.el-step >>> .el-step__title{
  line-height: 24px;
}
.el-step >>> .el-step__title.is-process  i{
  opacity: 1 !important;
}
.el-step >>> .el-step__head.is-process > .el-step__icon{
  background-color: #0171bb;
}
.el-step >>> .el-step__icon-inner {
  display: none;
}
.el-step >>> .el-step__icon {
  width: 15px;
  height: 15px;
  top: 2px;
}
.el-step >>> .el-step__icon:hover{
  cursor: pointer;
}
.el-step__main >>> .el-step__description {
  font-size: 14px;
  font-weight: 400;
  color: #404040;
  line-height: 24px;
}
.el-icon--right {
  margin: 0;
}
.stepBlock {
  display: flex;
  margin-top: 170px;
  position: relative;
  margin-left: -30px;
}
.stepBlock > div:nth-of-type(1) {
  flex: 1;
  z-index: 999;
  margin-top: -10px;
  margin-right: -70px;
}
.stepBlock > div:nth-last-of-type(1) {
  margin-top: -10px;
  margin-left: -110px;
}
.el-button {
  padding: 0;
  position: absolute;
}
.el-icon {
  font-size: 20px;
}
.el-step.is-center >>> .el-step__description {
  padding: 0;
}

.el-steps > .el-step:nth-child(even) >>> .el-step__main {
  position: absolute;
  bottom: 136px;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
}
.el-step:first-child >>> .el-step__description {
  padding-left: 100px;
}
.el-steps > .el-step:hover >>> .el-step__main > .el-step__title {
  font-weight: 700;
  color: #303133;
}
.el-steps > .el-step:hover >>> .el-step__main > .el-step__description {
  color: #303133;
}
/* 自定义步骤条end */
.timeLine {
  display: none;
}
.title {
  font-size: 40px;
  color: #333;
}
.title > span:nth-of-type(2) {
  color: #0171bb;
}
.img_box {
  width: 100%;
  height: 400px;
  background-image: url(../assets/aboutus.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img_center {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  color: #ffffff;
}
.img_title {
  width: 100%;
  margin-top: 152px;
  font-size: 60px;
}
.img_content {
  width: 1000px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 20px;
  margin-top: 26px;
  text-align: left;
  /* text-indent: 2em; */
}
.el-button--primary.is-disabled {
  background-color: #aeb2bd;
}
.el-button--primary {
  background-color: #0171bb;
}
.el-button {
  border-radius: 0;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 0;
}
.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 80px;
  position: relative;
}
@media (min-width: 768px) {
  .contentCenter,
  /* .map {
    width: 800px;
  } */
  .contentCenter {
    width: 100%;
  }
}
@media (min-width: 1000px) {
  .contentCenter,
  .map {
    width: 970px;
  }
}
@media (min-width: 1280px) {
  .contentCenter,
  .map {
    width: 1200px;
  }
}
.title {
  text-align: center;
  margin-top: 100px;
}
.text {
  text-align: center;
  font-size: 20px;
  color: #bdbdbd;
  margin-top: 10px;
}
.park,
.certificate {
  display: flex;
  margin-top: 70px;
}
.park {
  justify-content: space-between;
}
.parkLi {
  width: 33%;
  position: relative;
  overflow: hidden;
}
.parkLi img {
  width: 100%;
  height: 280px;
}
.parkText {
  padding: 10px 20px;
  box-sizing: border-box;
  height: 100px;
  background-color: #ffffff;
  border: 1px solid #aeb2bd;
  box-sizing: border-box;
  font-size: 14px;
  width: 100%;
}
.parkTextTitle {
  font-size: 18px;
  font-weight: bold;
  color: #404040;
}
.parkSamllText {
  color: #404040;
  margin-top: 10px;
}
.certificateLeft {
  width: 160px;
  display: flex;
  flex: 0 0 160px;
  flex-direction: column;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  margin-right: 36px;
}

.certificateLeftTitle {
  height: 80px;
  width: 100%;
  background: #aeb2bd;
  line-height: 80px;
  margin-bottom: 22px;
}
.certificateLeftTitle:hover {
  background-color: #0171bb;
  cursor: pointer;
}
.isCurrent {
  background-color: #0171bb;
}
.certificateRight {
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 540px;
}
.certificateRightLi {
  height: 260px;
}
.map {
  /* height: 540px; */
  margin-top: 70px;
}
.certificateLeftBtn div {
  width: 100%;
  height: 50%;
}
.home_title {
  position: absolute;
  top: -350px;
  width: 931px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  text-align: center;
}
.home_title1 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  line-height: 24px;
  margin-bottom: 30px;
}
.certificateRightLi img {
  width: 100%;
  object-fit: contain;
}
.certificateRightLi {
  box-sizing: border-box;
  width: 220px;
  height: 260px;
  overflow: hidden;
  border: 1px solid #aeb2bd;
  margin-bottom: 10px;
  display: flex;
}
.el-button {
  /* border-radius: 50%; */
  width: 40px;
  height: 40px;
  border: none;
}
@media (max-width: 1200px) {
  .home_title {
    width: 85%;
  }
  .contentCenter {
    width: 100%;
  }
  .parkLi img {
    width: 100%;
  }
  .parkText {
    position: relative;
  }
  .certificateLeft {
    margin-left: auto;
    margin-right: auto;
  }
  #allmap {
    width: 100%;
  }

  #allmap img {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 425px) {
  .content {
    padding-bottom: 50px;
  }
  .home_title {
    font-size: 12px;
  }
  .home_title1 {
    font-size: 40px;
  }
  .home_content {
    line-height: 22px;
    /* text-indent: 2em; */
  }
  .title span {
    font-size: 25px;
  }
  .parkSamllText {
    color: #8d8d8d;
    margin-top: 7px;
  }
  .park {
    flex-direction: column;
    margin-top: 50px;
  }
  .parkLi {
    width: 100%;
  }
  .parkLi img {
    display: block;
    width: 101%;
  }
  .parkText {
    height: auto;
    border: none;
  }
  .certificateLeft {
    width: auto;
    flex-direction: row;
  }
  .certificate {
    flex-direction: column;
    margin-top: 50px;
  }
  .certificateRight {
    width: 100%;
    padding: 0 10px;
    height: 713px;
  }
  .certificateRightLi {
    width: 50%;
    margin: 0;
    height: auto;
  }
  .el-steps--vertical {
    padding: 0 10px;
  }
  .certificateRightLi img {
    width: 100%;
    height: 100%;
  }
  .certificateLeftBtn {
    width: auto;
    height: auto;
  }
  .certificateLeft {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .certificateLeftTitle {
    height: 40px;
    line-height: 40px;
    margin-bottom: 0;
  }
  .img_center {
    width: 100%;
  }
  .img_title {
    font-weight: bold;
    font-size: 30px;
    margin-top: 100px;
  }
  .img_content {
    font-size: 12px;
    line-height: 18px;
    /* text-indent: 2em; */
    width: 90%;
    margin-top: 20px;
    text-align: left;
    /* text-indent: 2em; */
  }
  .img_box {
    height: 270px;
  }
  .title {
    margin-top: 50px;
    font-size: 30px;
  }
  .map {
    margin-top: 50px;
    /* height: 400px; */
  }
  .timeLine {
    display: block;

    margin-top: 40px;
  }
  .stepBlock {
    display: none;
  }
  .el-timeline {
    padding-right: 15px;
    padding-left: 15px;
    font-size: 12px;
  }
  .el-timeline >>> .el-timeline-item__timestamp {
    font-size: 18px;
    padding-top: 0;
  }
  .parkTextTitle {
    font-size: 16px;
  }
  .parkText {
    font-size: 12px;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companyIntroduction.vue